module.exports = __webpack_public_path__ + "static/media/feed_yellow.9a966ca1.svg";